module.exports = __webpack_public_path__ + "static/IBMPlexSans-Text-493a8d6f8c41cddd8ae814b29528d4b5.woff2";